import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { setComponent, setDefaultState } from '../../store/sessionStatus';

import ChangeDeviceWarning from '../changeDeviceWarning/ChangeDeviceWarning';
import RotateDeviceWarning from '../rotateDeviceWarning/RotateDeviceWarning';

import Button from '../../components/button/Button';

import instrukta from '../../assets/images/instruckta.svg';
import icon1 from '../../assets/images/icon1.webp';
import icon2 from '../../assets/images/icon2.webp';
import icon3 from '../../assets/images/icon3.webp';
import icon4 from '../../assets/images/icon4.webp';
import icon5 from '../../assets/images/icon5.webp';

import './menu.css';

export default function Menu() {
    const dispatch = useDispatch();

    const action = (component) => {
        dispatch(setComponent(component));
    };
    return (
        <div id="menuWrapper">
            <div className="menuTitle">
                <img src={instrukta} alt="iNSTRUCKTA!" />
            </div>

            <div id="menuContent">
                <Link to="/quiz" onClick={() => action('question')}>
                    <Button type={'squareButton resume'} text="Resume Quiz" />
                </Link>
                <Link to="/quiz" onClick={() => action('currentScore')}>
                    <Button type={'squareButton currScore'} text="Your Score" />
                </Link>
                <Link to="/" onClick={() => dispatch(setDefaultState())}>
                    <Button type={'squareButton restart'} text="Restart" />
                </Link>
            </div>

            <img id="icon1Menu" src={icon1} alt="decor" />
            <img id="icon2Menu" src={icon2} alt="decor" />
            <img id="icon3Menu" src={icon3} alt="decor" />
            <img id="icon4Menu" src={icon4} alt="decor" />
            <img id="icon5Menu" src={icon5} alt="decor" />
            <ChangeDeviceWarning />
            <RotateDeviceWarning />
        </div>
    );
}
